<div class="toggle-buttons">
  @for (button of buttons; track button) {
    @if (button.visible !== false) {
      <button
        type="button"
        class="btn"
        [disabled]="disabled"
        [ngClass]="button.isActive ? 'btn-primary' : 'btn-secondary'"
        (click)="onButtonClick(button)"
      >
        <div class="btn-lbl">
          @if (button.icon) {
            <fa-icon
              class="fa-icon"
              [icon]="button.icon"
              size="2x"
              [ngStyle]="{
                'background-color':
                  button?.background || 'var(--color-static-brand)',
              }"
            ></fa-icon>
          }
          <span class="lbl">{{ button.label }}</span>
        </div>
      </button>
    }
  }
</div>
